"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dayjs = _interopRequireDefault(require("dayjs"));
var _eventHub = _interopRequireDefault(require("@/utils/eventHub"));
var _default = exports.default = {
  props: {
    dataInfo: {},
    eventList: {}
  },
  data: function data() {
    return {
      currentTime: (0, _dayjs.default)().format('YYYY-MM-DD HH:mm:ss'),
      config: {
        header: ['时间', '温度', '主机', '模式', '功率'],
        data: [['25:30', '25℃', '主机1', '5', '10'], ['26:00', '25℃', '主机2', '1', '10'], ['26:30', '25℃', '主机3', '6', '10'], ['27:00', '25℃', '主机4', '2', '10'], ['28:30', '25℃', '主机5', '1', '10'], ['29:00', '25℃', '主机6', '3', '10'], ['30:30', '25℃', '主机7', '4', '10'], ['31:00', '25℃', '主机8', '2', '10'], ['32:30', '25℃', '主机1', '5', '10'], ['33:00', '25℃', '主机2', '3', '10']],
        // index: true,
        // columnWidth: [50, 170, 300],
        align: ['center'],
        rowNum: 8,
        headerBGC: '#1981f6',
        headerHeight: 45,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      },
      sfconfig: {
        data: [{
          name: '送风频率',
          value: 80
        }, {
          name: '送风温度',
          value: 25
        }, {
          name: '回风温度',
          value: 26
        }],
        showValue: true
      },
      configWd: {
        data: [29],
        shape: 'round',
        formatter: '{value}℃'
      },
      configRsxWd: {
        data: [29],
        formatter: '{value}℃',
        colors: ['#FF9999', '#FF6666']
      }
    };
  },
  methods: {
    updateTime: function updateTime() {
      this.currentTime = (0, _dayjs.default)().format('YYYY-MM-DD HH:mm:ss');
    },
    goToMananger: function goToMananger() {
      this.removeCssrender();
      // 返回上一层
      window.history.go(-1);
    },
    removeCssrender: function removeCssrender() {
      var elementToRemove = document.querySelector('.cssrender');
      console.log("xiezai{}", elementToRemove);
      // 检查元素是否存在
      if (elementToRemove) {
        // 清空元素的内容
        elementToRemove.innerHTML = '';
      }
    }
  },
  created: function created() {
    setInterval(this.updateTime, 1000);
  },
  unmounted: function unmounted() {
    this.removeCssrender();
  }
};